"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const AddressWithConnections_1 = tslib_1.__importDefault(require("./AddressWithConnections"));
const GetOfferWithEstimatesRequest_1 = require("../GetOfferWithEstimatesRequest");
class GetOfferWithEstimatesRequestV2 extends base_models_1.Serializable {
    constructor() {
        super(...arguments);
        this.maxPackages = 3;
    }
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.SegmentType)),
    (0, base_models_1.Docs)({
        example: base_models_1.SegmentType.SOHO,
        description: 'The type of segment the address falls in.',
    }),
    tslib_1.__metadata("design:type", String)
], GetOfferWithEstimatesRequestV2.prototype, "segmentType", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, base_models_1.MultiValue)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.DurationInYears), { each: true }),
    (0, base_models_1.Docs)({
        example: [base_models_1.DurationInYears.FLEX, base_models_1.DurationInYears.ONE],
        description: `Filter for which contract duration you want the offers.
If it is left empty, it will fetch contract with all the possible durations.`,
    }),
    tslib_1.__metadata("design:type", Array)
], GetOfferWithEstimatesRequestV2.prototype, "durations", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => AddressWithConnections_1.default),
    tslib_1.__metadata("design:type", Array)
], GetOfferWithEstimatesRequestV2.prototype, "addresses", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({ maxDecimalPlaces: 0 }),
    (0, class_validator_1.Min)(1),
    (0, class_validator_1.Max)(5),
    (0, class_transformer_1.Type)(() => Number),
    (0, base_models_1.Docs)({
        example: 2,
        description: 'The max number of packages that should be returned. Defaults to maximum of three.',
    }),
    tslib_1.__metadata("design:type", Number)
], GetOfferWithEstimatesRequestV2.prototype, "maxPackages", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(GetOfferWithEstimatesRequest_1.FunnelType)),
    (0, base_models_1.Docs)({
        example: 'acquisition',
        description: `Funnel type for the returned offers, can be either 'acquisition' or 'retention'`,
        defaultValue: GetOfferWithEstimatesRequest_1.FunnelType.RETENTION,
    }),
    tslib_1.__metadata("design:type", String)
], GetOfferWithEstimatesRequestV2.prototype, "funnelType", void 0);
exports.default = GetOfferWithEstimatesRequestV2;
